import React from 'react';
import './Gifting.css';

export default function Gifting() {
  return (
    <div className="page-wrapper gifting-page">
      <div className="section-header">
        <span className="section-eyebrow">Bless Our Journey</span>
        <h2 className="section-title">Gifting <em>Options</em></h2>
        <div className="gold-line" />
      </div>

      <div className="gifting__inner">
        <p className="gifting__intro fade-up">
          Your presence at our celebration is the greatest gift of all.
          If you'd like to bless us further, we've made it easy.
          Please note that no physical gifts will be accepted at the venue.
        </p>

        <div className="gifting__cards">
          <a
            className="gifting__card fade-up"
            href="https://www.amazon.co.uk/wedding/share/ayobamiandayotomide"
            target="_blank"
            rel="noreferrer"
          >
            <span className="gifting__card-symbol">◈</span>
            <h3 className="gifting__card-title">Wedding Registry</h3>
            <p className="gifting__card-desc">
              Browse our curated wish list and choose something
              special for our home and new life together.
            </p>
            <span className="gifting__card-link">View Registry →</span>
          </a>

          <a
            className="gifting__card fade-up"
            href="https://monzo.me/ayobamimohammed4?h=y3zUt1"
            target="_blank"
            rel="noreferrer"
          >
            <span className="gifting__card-symbol">✦</span>
            <h3 className="gifting__card-title">Monetary Gift</h3>
            <p className="gifting__card-desc">
              A financial contribution towards our future together
              is warmly welcomed and deeply appreciated.
            </p>
            <span className="gifting__card-link">Give a Gift →</span>
          </a>
        </div>
      </div>
    </div>
  );
}